import { Alert, Box, Container, Typography } from "@mui/material";
import React, { useCallback, useState } from "react";
import BackBtn from "../../widgets/BackBtn";
import useApiEp from "../../hooks/useApiEp";
import MuPb from "../../widgets/MuPb";
import { getErrorResponse } from "../../utils/util";
import DataTable from "../../widgets/DataTable";
import RenderStatusMessage from "../../widgets/RenderStatusMessage";
import { useNavigate } from "react-router-dom";

const AgentNotifications = () => {
  const [page, setPage] = useState(1);
  const limit = 10;
  const navigate = useNavigate();

  const { data, isLoading, isError, error } = useApiEp(
    `/api/get-agent-notifications?page=${page}&limit=${limit}`
  );

  const handleAction = useCallback((action, id) => {
    switch (action) {
      case "view":
        navigate(`/home/${id}/message-detail?isRcs=false`);
        break;
        break;
      default:
        console.warn("unknown action", id);
    }
  }, []);

  if (isLoading) return <MuPb />;
  if (isError) return <Alert severity="error">{getErrorResponse(error)}</Alert>;

  return (
    <Container sx={{ mt: 3 }}>
      <BackBtn />
      <Typography variant="h6" sx={{ mb: 2 }}>
        Agent Notifications
      </Typography>
      <Box>
        <DataTable
          sx={{ mb: 1 }}
          columns={[
            {
              id: "serial",
              label: "S.No.",
              render: (_v, _row, idx) => (page - 1) * limit + idx + 1,
            },
            { id: "cusId", label: "Customer" },
            { id: "to", label: "Recipient" },
            { id: "from", label: "From" },
            {
              id: "status",
              label: "Status",
              render: (v) => <RenderStatusMessage status={v} />,
            },
            {
              id: "body",
              label: "Message",
              render: (v) => (
                <Typography
                  variant="body2"
                  sx={{
                    maxWidth: 300,
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                  title={v}
                >
                  {v}
                </Typography>
              ),
            },
            {
              id: "createdOn",
              label: "Created On",
              render: (v) =>
                new Date(v).toLocaleString("en-IN", {
                  dateStyle: "medium",
                  timeStyle: "short",
                }),
            },
          ]}
          actions={["view"]}
          rows={data?.data ?? []}
          page={page}
          limit={limit}
          totalPages={data?.totalPages ?? 1}
          onPageChange={setPage}
          onAction={handleAction}
        />
      </Box>
    </Container>
  );
};

export default AgentNotifications;
